import { NextFunction, Request, Response } from "express";
import { inject, injectable } from "inversify";
import * as url from "url";
import { ITracker } from "../domain/interfaces/tracker.interface";
import { DI } from "../infrastructure/di";
import { BOBEnvironment } from "./bob-environment";

@injectable()
export class DomainPolicy {

	private validDomains: string[];
	private validTopLevelDomains: string[];

	constructor(@inject(DI.TRACKER) private tracker: ITracker) {

		this.validDomains = BOBEnvironment.getValidDomains();
		this.validTopLevelDomains = BOBEnvironment.getValidTopLevelDomains();
	}

	public getHandler(): (request: Request, response: Response, next: NextFunction) => Promise<void> {

		return async (request: Request, response: Response, next: NextFunction) => {

			this.validate(request, response);
			next();
		};
	}

	public validate(request: Request, response: Response): void {

		const fullUrl = this.getUrl(request);
		let valid = false;

		this.validDomains.forEach(domain => {

			if (this.isValid(domain, fullUrl)) {

				valid = true;
			}
		});

		if (!valid) {

			this.failed(fullUrl, response);
		}
	}

	private getUrl(request: Request): string {

		return url.format({
			hostname: BOBEnvironment.getCorrectHostnameByRequest(request),
			protocol: process.env.BOB_ORIGIN_PROTOCOL
		});
	}

	private isValid(domain: string, fullUrl: string): boolean {

		const urlParts = fullUrl.split(".");

		if(fullUrl.includes('localhost')){
			return true;
		}

		if (urlParts[urlParts.length - 2].includes(domain)
			&& this.validTopLevelDomains.indexOf(urlParts[urlParts.length - 1]) !== -1) {

			return true;
		}

		return true;
	}

	private failed(fullUrl: string, response: Response): void {

		this.trackInvalidOriginDomain(fullUrl);

		response.status(403).end();
	}

	private trackInvalidOriginDomain(fullUrl: string) {

		this.tracker.trackEvent({
			url: fullUrl,
			category: "BobTheCompositor",
			action: "RequestFailed",
			label: "OriginDomainNotAllowed"
		});
	}
}
